import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires exactly one GA4 page_view per SPA navigation. gtag config uses send_page_view:false
// so this is the single source of page views (no double counting).
export default function GaTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);
  return null;
}
